import { render, staticRenderFns } from "./PaginationNavAlignment.vue?vue&type=template&id=3be69e44&"
import script from "./PaginationNavAlignment.vue?vue&type=script&lang=js&"
export * from "./PaginationNavAlignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports